// extracted by mini-css-extract-plugin
export default {"Pagehead":"RulesPanel-module__Pagehead--uqIPI"};